import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import * as React from 'react';
import { apiUrl } from '../pages/UrlParam';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AxiosFetchData from '../pages/AxiosFetchData';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PageviewIcon from '@mui/icons-material/Pageview';
import ImageView from '../components/ImageView';
import ImageViewer from '../components/ImageViewer';
import Bindcomponent from '../utils/bindcomponent';
import { useSearchParams } from 'react-router-dom';
import { read } from '@popperjs/core';

const UploadFiles = (props) =>{
    let uploadObj;
    const pathAPI = {
        saveUrl: `${apiUrl}/api/UploadFiles`
    }

    let dropAreaRef;

    const [list,setList] = React.useState([])
    const [roleaccess,setRoleaccess] = React.useState({
                CREATE : true,
                READ : true,
                UPDATE : true,
                DELETE : true
            })
    const [path,setPath] = React.useState('')
    const [isOpen,setIsOpen] = React.useState(false)
    const [filename,setFilename] = React.useState('')

    React.useEffect(()=>{
        GetFiles()
    },[])

    const onUploadSuccess = async (args) =>  {
        try{
            let data ={
                path : (JSON.parse(args.e.currentTarget.response)).data.file_path,
                description : null,
                type : props.type,
                reference_id : props.id,
                mime : args.file.rawFile.type,
                file_name : args.file.name
            }
         
            var resp = await AxiosFetchData.post(`AddFiles`,data).refreshToken(props.navigate, props.table);
           // this.setState({roleaccess : resp.roleaccess})
            setRoleaccess({roleaccess : resp.roleaccess})
            await GetFiles()
        }catch(err){
            alert(err.message)
        }
         
    }
    const onCreated= async ()=> {
        await GetFiles()
        uploadObj.dropArea = dropAreaRef;
        uploadObj.dataBind();
    } 
        
    const handleClose = val =>{
        props.handleClose();
           
    }
    
    function handleImageIcon(row)
    {
             if(row.mime.includes('image')){
                    return row.path;
             }
    
             if(row.mime.includes('pdf')){
                return 'uploads/pdf.png';
             }
    
             if(row.mime.includes('vnd.ms-excel') || row.mime.includes('vnd.openxmlformats-officedocument.spreadsheetml.sheet')){
                return 'uploads/excel.png';
             }
    
             if(row.mime.includes('msword') || row.mime.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')){
                return 'uploads/word.png';
             }
     }
    
     const GetFiles =  async () =>{
        console.log('aaa')
         try{
            var files = await AxiosFetchData.get(`GetFiles/${props.id}/${props.type}`).refreshToken(props.navigate,props.table);
            const rows = files.data.map((row, index) => ({
                ...row,
                imageIcon :  handleImageIcon(row)
              }));
              setList(rows)
              setRoleaccess(files.roleaccess)
            
         }catch(e){
            console.log(e)
         }
          
    } 
         
    
    const handleImageClick= async (id,path) => { 
           try{
                await AxiosFetchData.delete(`DeleteFiles/${id}/${encodeURIComponent(path)}`).refreshToken(props.navigate,"invoice")
                await GetFiles()
            }catch(e){
                alert(e.message)
           }
    }

    return (
                <>
                <Dialog
                    open = {props.productopen}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth
                >
                    <form  role="form"> 
                    <DialogTitle>UPLOAD DOCUMENT </DialogTitle>
                    <DialogContent>
                       
                        <div className='row mb-6'>
                        {list.length > 0 && (
                        <ImageList sx={{ width: "100%", height: "100%", overflow:'auto' }} cols={5} rowHeight={100}  gap={8} variant='quilted' >
                            {list.map((item) => (
                                <ImageListItem key={item.id}  >
                                  
                                    <img
                                        srcSet={`${apiUrl + '/' + item.imageIcon}?w=50&fit=crop&auto=format&dpr=2 2x`}
                                        src={`${apiUrl + '/' + item.imageIcon}?w=50&fit=crop&auto=format`}
                                        alt={item.file_name}  
                                        loading="lazy"
                                     
                                    />
                                    <ImageListItemBar
                                        subtitle={item.file_name}
                                        position="bottom"
                                        actionPosition="left"
                                    />
                                        <ImageListItemBar
                                            position="top"
                                            actionIcon={
                                            <IconButton
                                                sx={{ color: 'white' }}
                                                aria-label={`star ${item.title}`}>
                                                <DeleteOutlineIcon  onClick={async () => await  handleImageClick(item.id, item.path)} />
                                                <PageviewIcon onClick={() =>{
                                                    if(item.mime.includes('image')){
                                                        setIsOpen(true)
                                                        setPath(item.path)
                                                        setFilename(item.file_name)
                                                       
                                                    }else{
                                                        window.open(`${apiUrl}/${item.path}`);
                                                    }
                                                       
                                                } 
                                                }></PageviewIcon>
                                            </IconButton>
                                            }
                                            actionPosition="left"
                                        />
                                </ImageListItem>
                            ))}
                        </ImageList>
                        )}
                        
                        </div>
                        <DialogContentText>
                        <h5>only for extension ./jpg, .gif, .png, ./doc, .docx, ./xls, .xlsx, and .pdf</h5>
                        </DialogContentText>
                      
                        <div className='row mb-6'>
                            <div className='col-lg-12'>
                            <div className = 'control-pane'>
                                <div className='control-section row uploadpreview'>
                                <div className='col-lg-12'>
                                <div className='upload_wrapper'>
                                {/* Render Uploader */}
                                    <UploaderComponent id='fileUpload' type='file' ref = {upload => {uploadObj = upload }} allowedExtensions='.jpg, .png, .gif, .jpeg, .xlsx, .pdf, .xls, .doc'
                                        asyncSettings = {pathAPI} 
                                        disabled={!roleaccess.CREATE}
                                        success={onUploadSuccess} created={onCreated} 
                                        />
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                       
                    </DialogContent>
                    <DialogActions>
                        <button className='btn' onClick={handleClose} type='button'>CLOSE {roleaccess.CREATE}</button>
                    </DialogActions>
                    </form>
                    </Dialog>
                    
                    <Bindcomponent component='ImageViewer' path={path} productopen={isOpen} setproductopen={setIsOpen} filename={filename} ></Bindcomponent>
                    {/* <ImageViewer path={path} productopen={isOpen} setproductopen={setIsOpen} filename={filename} ></ImageViewer>  */}
                </>
            );
            
}

export default  UploadFiles